export function Create(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/goals`;
}

export function Delete(organizationID: number, goalID: number): string {
	return `/v1/organizations/${organizationID}/user-goals/${goalID}`;
}

export function Update(organizationID: number, goalID: number): string {
	return `/v1/organizations/${organizationID}/user-goals/${goalID}`;
}

export function UserIndex(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/goals`;
}

